import React, { useContext, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { DataContext } from '../contexts/DataContext';

const FreightUnderManagementCard = () => {
  const { shipments } = useContext(DataContext);
  const [freightUnderManagement, setFreightUnderManagement] = useState(0);

  useEffect(() => {
    // Calculate the sum of recognizedWip for all shipments
    const totalRecognizedWip = shipments.reduce((acc, shipment) => acc + (shipment.recognizedWip || 0), 0);
    setFreightUnderManagement(totalRecognizedWip);
  }, [shipments]);

  // Format the sum to a money format
  const formattedFreightUnderManagement = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // Optional: To display a specific number of decimal places:
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(freightUnderManagement);

  return (
    <div className="bg-white shadow rounded-lg p-6 w-full max-w-lg h-custom-card-small">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-gray-800 flex items-center">
          <FontAwesomeIcon icon={faDollarSign} className="text-green-600 mr-3" />
          Freight Under Management
        </h2>
        <a href="/freight-management" className="text-md text-blue-600 hover:text-blue-800 transition duration-300">
          View details
        </a>
      </div>
      <div className="text-center">
        <FontAwesomeIcon icon={faDollarSign} className="text-green-600 text-3xl mb-2" />
        <p className="text-md text-gray-600">Total Freight</p>
        <p className="text-2xl font-semibold text-gray-800">{formattedFreightUnderManagement}</p>
      </div>
    </div>
  );
};

export default FreightUnderManagementCard;
